module.exports = __webpack_public_path__ + "assets/2-NYC-Tech-Sales-Careers.19fba6df.png";